<template>
  <div>
    <div class="screeds-container">


      <div class="screeds-list" v-if="screeds.length > 0">
        <div v-for="(screed, index) in screeds" :key="index" class="screed-item">
          <span class="screed-number">{{ screed.No }}</span>
          <button class="btn btn-sm btn-outline-danger screed-remove" @click="removeScreeds(index)"
            v-b-tooltip.hover.left="'Видалити'">
            <i class="far fa-trash-alt"></i>
          </button>
        </div>
      </div>

      <div class="materials-empty">
        <div class="add-material-button" @click="addScreed">
          <div class="add-button-content">
            <i class="fas fa-plus"></i>
            <span>Додати стяжку</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toInteger } from "lodash";

export default {
  name: "screeds",
  computed: {
    screeds() {
      return this.$store.state.data.screeds;
    }
  },
  methods: {
    addScreed() {
      this.$store.commit('data/ADD_SCREED', {
        No: this.screeds.length > 0 ? toInteger(this.screeds[this.screeds.length - 1].No) + 1 : 2
      })
    },
    removeScreeds(i) {
      this.$store.commit('data/REMOVE_SCREED', i)
    }
  }
}
</script>
<style scoped>
.screeds-container {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 10px;
  width: 100%;
}

.screeds-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid #dee2e6;
}

.screeds-title {
  margin: 0;
  font-size: 0.85rem;
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 6px;
}

.screeds-title i {
  color: #2c5aa0;
  font-size: 0.8rem;
}

.screeds-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 300px;
  overflow-y: auto;
  padding-right: 4px;
}

/* Custom Scrollbar */
.screeds-list::-webkit-scrollbar {
  width: 6px;
}

.screeds-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.screeds-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.screeds-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.screed-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  padding: 6px 8px;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}

.screed-item:hover {
  background: #f8f9fa;
  border-color: #2c5aa0;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.screed-number {
  font-weight: 500;
  color: #495057;
  font-size: 0.85rem;
}

.screed-remove {
  padding: 3px 6px;
  font-size: 0.7rem;
  line-height: 1;
}


.materials-empty {
  margin-top: 5px;
  text-align: center;
  color: #6c757d;
}

.materials-empty i {
  margin-right: 6px;
}

/* Add Material Button */
.add-material-button {
  border: 2px dashed #2c5aa0;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(44, 90, 160, 0.02);
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-material-button:hover {
  background: rgba(44, 90, 160, 0.08);
  border-color: #1e4a8a;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(44, 90, 160, 0.15);
}

.add-button-content {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  color: #2c5aa0;
}

.add-button-content i {
  font-size: 1.5rem;
  color: #2c5aa0;
  margin: 0;
}

.add-button-content span {
  font-size: 0.9rem;
  font-weight: 500;
  color: #2c5aa0;
}

/* Bootstrap button overrides */
.btn-sm {
  padding: 3px 6px;
  font-size: 0.7rem;
}

.btn-primary {
  background-color: #2c5aa0;
  border-color: #2c5aa0;
  color: white;
  padding: 8px 16px;
  font-size: 0.9rem;
  font-weight: 500;
}

.btn-primary:hover {
  background-color: #1e4a8a;
  border-color: #1e4a8a;
}

.btn-outline-danger {
  color: #dc3545;
  border-color: #dc3545;
}

.btn-outline-danger:hover {
  background-color: #dc3545;
  border-color: #dc3545;
  color: white;
}

.hidend {
  display: none;
}
</style>